import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css'; 
import { useAppContext } from "../../Context/Store";

export function SocialSlider({SocialFeedheadingDataDynamic, SocialFeedItemsDataDynamic, FollowUsTextDataDynamic}) {
    const { domainURL, domainURLCMS } = useAppContext(); 
    
      //console.log("Social Feed", SocialFeedItemsDataDynamic);

const SocialSliderData = {
    id: 1,
    SocialMediaList: [
        {id: 1, IconText: 'facebook', IconUrl: 'https://www.facebook.com/promovara/'},
        {id: 2, IconText: 'instagram', IconUrl: 'https://www.instagram.com/promovaraofficial/'},
        {id: 3, IconText: 'linkedin', IconUrl: 'https://www.linkedin.com'},
        {id: 4, IconText: 'tiktok', IconUrl: 'https://www.tiktok.com'},
        {id: 5, IconText: 'youtube', IconUrl: 'https://www.youtube.com/@Promovara'}
    ]
} 
const { SocialMediaList } = SocialSliderData;
const options = {
    //responsiveClass: true,
    items:6,
        loop:true,
        margin:15,
        nav:false,
        slideBy: 1,
        autoplay:true,
        autoplayTimeout:2500,
        //stagePadding: 50,
        autoplayHoverPause:true,
        //center: true,
        //autoWidth:true,
        //animateOut: 'fadeOut',
        //animateOut: 'slideOutDown',
        //animateIn: 'flipInX',
        //smartSpeed:450,
		navText: [
			'<span aria-label="' + 'Previous' + '">&#x2039;</span>',
			'<span aria-label="' + 'Next' + '">&#x203a;</span>'
		],
		navSpeed: false,
		navElement: 'button type="button" role="presentation"',
		navContainer: false,
		navContainerClass: 'owl-nav',
		navClass: [
			'owl-prev',
			'owl-next'
		], 
		dotClass: 'owl-dot',
		dotsClass: 'owl-dots',
		dots: false,
        responsive:{
            0:{
                items:2
            },
            768:{
                items:6
            }
        }
};
const SocialIcons = SocialMediaList.map((data)=>
    { 
        const { id, IconText, IconUrl } = data;
        return ( 
            <a key={id} className={`icon ir ${IconText}`} href={IconUrl} target="_blank">{IconText}</a>
        )
    })

  return (
    <> 
      <section className="follow-us new-box">
            <div className="inner">
                <div className="details">
                    <h2>{SocialFeedheadingDataDynamic}</h2>
                    <div className="icons">
                        {SocialIcons}
                    </div>
                </div>
            </div>
        </section>
        
        <section className="instagram-feed">
            <OwlCarousel className="owl-carousel owl-theme" {...options}>
                {
                    Array.isArray(SocialFeedItemsDataDynamic) && SocialFeedItemsDataDynamic.map((item, index) => {
                        const idValue = index;
                        //console.log(idValue);
                        return (
                            <div key={item?.id || idValue}> {/* Use item.id if available, otherwise fallback to index */}
                                {/* <p>{idValue}</p> */}
                                {
                                    Array.isArray(item?.content?.properties?.image) && item?.content?.properties?.image.map((itemChild) => {
                                        //console.log(itemChild);
                                        return (
                                            <article key={itemChild?.id || `${idValue}-${itemChild.id}`} className="item amenity">
                                                <figure>
                                                    <img src={`${domainURLCMS}${itemChild?.url}`} alt="" />
                                                </figure>
                                            </article>
                                        );
                                    })
                                } 
                            </div>
                        );
                    })
                }
                {/* {SocialSliderList.map((data)=>
                    { 
                        const { id, Image } = data;
                        return ( 
                            <article key={id} className="item amenity">
                                <figure>
                                    <img src={Image} alt="" />
                                </figure>
                            </article>
                        )
                    })} */}
            </OwlCarousel>
        </section>
        <section className="follow-us">
            <div className="inner">
                <div className="details">
                    <h2>
                        <span>{SocialFeedheadingDataDynamic}</span>
                        {SocialIcons}
                    </h2>
                </div>
            </div>
        </section>
    </>
  )
}
